import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-review',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminReviewComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public reviews: any[] = [];
    public page: number = 1;
    public lastpage: number = 1;

    // 필터
    public statusFilter: string = '';
    public typeFilter: string = '';
    public statuses: string[] = ['', 'pending', 'approved', 'rejected', 'revision', 'hold'];
    public statusLabels: any = { '': '전체', pending: '대기', approved: '승인', rejected: '반려', revision: '보정', hold: '보류' };
    public targetTypes: string[] = ['', 'summary', 'qa', 'roi', 'entity', 'term'];
    public typeLabels: any = { '': '전체', summary: '요약', qa: 'Q&A', roi: 'ROI', entity: '엔터티', term: '용어' };

    // 상세/액션
    public selectedReview: any = null;
    public decisions: any[] = [];
    public actionDecision: string = '';
    public actionNote: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.loading = true;
        this.page = page;
        await this.service.render();

        const { code, data } = await wiz.call("review_list", {
            status: this.statusFilter,
            target_type: this.typeFilter,
            page: this.page,
        });

        if (code === 200 && data) {
            this.reviews = data.list || [];
            this.lastpage = data.lastpage || 1;
        }
        this.loading = false;
        await this.service.render();
    }

    public async filterStatus(s: string) {
        this.statusFilter = s;
        await this.load(1);
    }

    public async filterType(t: string) {
        this.typeFilter = t;
        await this.load(1);
    }

    public async showDetail(review: any) {
        const { code, data } = await wiz.call("review_get", { id: review.id });
        if (code === 200 && data) {
            this.selectedReview = data.workflow;
            this.decisions = data.decisions || [];
        } else {
            this.selectedReview = review;
            this.decisions = [];
        }
        this.actionDecision = '';
        this.actionNote = '';
        await this.service.render();
    }

    public closeDetail() {
        this.selectedReview = null;
        this.decisions = [];
        this.service.render();
    }

    public async submitAction() {
        if (!this.actionDecision || !this.selectedReview) return;
        const { code } = await wiz.call("review_action", {
            review_id: this.selectedReview.id,
            action: this.actionDecision,
            reason: this.actionNote,
        });
        if (code === 200) {
            this.selectedReview = null;
            await this.load(this.page);
        } else {
            await this.service.alert.show({ title: '오류', message: '처리에 실패했습니다.', action: '확인' });
        }
    }

    public statusColor(s: string): string {
        const colors: any = {
            pending: 'bg-yellow-100 text-yellow-700',
            approved: 'bg-green-100 text-green-700',
            rejected: 'bg-red-100 text-red-700',
            revision: 'bg-orange-100 text-orange-700',
            hold: 'bg-gray-100 text-gray-500',
        };
        return colors[s] || 'bg-gray-100 text-gray-500';
    }

    public pages(): number[] {
        const arr: number[] = [];
        for (let i = 1; i <= this.lastpage; i++) arr.push(i);
        return arr;
    }
}

export default PortalNrichadminAdminReviewComponent;